var нахуй = {
  type: 'non qualifying adverb',
  adverb: 'нахуй'
};

var хуёво = {
  type: 'qualifying adverb',
  adverb: 'хуёво',
  comparative: 'хуёвее',
  superlative: 'хуёвейше'
};

var нах = {
  type: 'non qualifying adverb',
  adverb: 'нах'
};

var заебись = {
  type: 'non qualifying adverb',
  adverb: 'заебись'
};

var охуенно = {
  type: 'qualifying adverb',
  adverb: 'охуенно',
  comparative: 'охуеннее',
  superlative: 'охуенней'
};

var adverbs = [заебись, нах, нахуй, охуенно, хуёво];

var ёба = {
  type: 'interjection',
  interjection: 'ёба'
};

var бля = {
  type: 'interjection',
  interjection: 'бля'
};

var блять = {
  type: 'interjection',
  interjection: 'блять'
};

var ёпт = {
  type: 'interjection',
  interjection: 'ёпт'
};

var interjections = [бля, блять, ёба, ёпт];

var блядь = {
  type: 'noun',
  nominativeSingular: 'блядь',
  genitiveSingular: 'бляди',
  dativeSingular: 'бляди',
  accusativeSingular: 'блядь',
  instrumentalSingular: 'блядью',
  prepositionalSingular: 'бляди',
  nominativePlural: 'бляди',
  genitivePlural: 'блядей',
  dativePlural: 'блядям',
  accusativePlural: 'блядей',
  instrumentalPlural: 'блядями',
  prepositionalPlural: 'блядях'
};

var пизда = {
  type: 'noun',
  nominativeSingular: 'пизда',
  genitiveSingular: 'пизды',
  dativeSingular: 'пизде',
  accusativeSingular: 'пизду',
  instrumentalSingular: 'пиздой',
  prepositionalSingular: 'пизде',
  nominativePlural: 'пизды',
  genitivePlural: 'пизд',
  dativePlural: 'пиздам',
  accusativePlural: 'пизды',
  instrumentalPlural: 'пиздами',
  prepositionalPlural: 'пиздах'
};

var пиздец = {
  type: 'noun',
  nominativeSingular: 'пиздец',
  genitiveSingular: 'пиздеца',
  dativeSingular: 'пиздецу',
  accusativeSingular: 'пиздец',
  instrumentalSingular: 'пиздецом',
  prepositionalSingular: 'пиздеце',
  nominativePlural: 'пиздецы',
  genitivePlural: 'пиздецов',
  dativePlural: 'пиздецам',
  accusativePlural: 'пиздецы',
  instrumentalPlural: 'пиздецами',
  prepositionalPlural: 'пиздецах'
};

var сука = {
  type: 'noun',
  nominativeSingular: 'сука',
  genitiveSingular: 'суки',
  dativeSingular: 'суке',
  accusativeSingular: 'суку',
  instrumentalSingular: 'сукой',
  prepositionalSingular: 'суке',
  nominativePlural: 'суки',
  genitivePlural: 'сук',
  dativePlural: 'сукам',
  accusativePlural: 'сук',
  instrumentalPlural: 'суками',
  prepositionalPlural: 'суках'
};

var хуй = {
  type: 'noun',
  nominativeSingular: 'хуй',
  genitiveSingular: 'хуя',
  dativeSingular: 'хую',
  accusativeSingular: 'хуй',
  instrumentalSingular: 'хуём',
  prepositionalSingular: 'хуе',
  nominativePlural: 'хуи',
  genitivePlural: 'хуёв',
  dativePlural: 'хуям',
  accusativePlural: 'хуи',
  instrumentalPlural: 'хуями',
  prepositionalPlural: 'хуях'
};

var долбоёб = {
  type: 'noun',
  nominativeSingular: 'долбоёб',
  genitiveSingular: 'долбоёба',
  dativeSingular: 'долбоёбу',
  accusativeSingular: 'долбоёба',
  instrumentalSingular: 'долбоёбом',
  prepositionalSingular: 'долбоёбе',
  nominativePlural: 'долбоёбы',
  genitivePlural: 'долбоёбов',
  dativePlural: 'долбоёбам',
  accusativePlural: 'долбоёбов',
  instrumentalPlural: 'долбоёбами',
  prepositionalPlural: 'долбоёбах'
};

var наебалово = {
  type: 'singular noun',
  nominativeSingular: 'наебалово',
  genitiveSingular: 'наебалова',
  dativeSingular: 'наебалову',
  accusativeSingular: 'наебалово',
  instrumentalSingular: 'наебаловом',
  prepositionalSingular: 'наебалове'
};

var хуета = {
  type: 'noun',
  nominativeSingular: 'хуета',
  genitiveSingular: 'хуеты',
  dativeSingular: 'хуете',
  accusativeSingular: 'хуету',
  instrumentalSingular: 'хуетой',
  prepositionalSingular: 'хуете',
  nominativePlural: 'хуеты',
  genitivePlural: 'хует',
  dativePlural: 'хуетам',
  accusativePlural: 'хуеты',
  instrumentalPlural: 'хуетами',
  prepositionalPlural: 'хуетах'
};

var хуйня = {
  type: 'singular noun',
  nominativeSingular: 'хуйня',
  genitiveSingular: 'хуйни',
  dativeSingular: 'хуйне',
  accusativeSingular: 'хуйню',
  instrumentalSingular: 'хуйнёй',
  prepositionalSingular: 'хуйне'
};

var заебумба = {
  type: 'singular noun',
  nominativeSingular: 'заебумба',
  genitiveSingular: 'заебумбы',
  dativeSingular: 'заебумбе',
  accusativeSingular: 'заебумбу',
  instrumentalSingular: 'заебумбой',
  prepositionalSingular: 'заебумбе'
};

var nouns = [блядь, долбоёб, заебумба, наебалово, пизда, пиздец, сука, хуета, хуй, хуйня];

var ёбнуть = {
  type: 'perfective verb',
  infinitive: 'ёбнуть',
  imperativePluralSecondPerson: 'ёбните',
  imperativeSingularSecondPerson: 'ёбни',
  indicativeFuturePluralFirstPerson: 'ёбнем',
  indicativeFuturePluralSecondPerson: 'ёбнете',
  indicativeFuturePluralThirdPerson: 'ёбнут',
  indicativeFutureSingularFirstPerson: 'ёбну',
  indicativeFutureSingularSecondPerson: 'ёбнешь',
  indicativeFutureSingularThirdPerson: 'ёбнет',
  indicativePastPlural: 'ёбнули',
  indicativePastSingularFeminine: 'ёбнула',
  indicativePastSingularMasculine: 'ёбнул',
  indicativePastSingularNeuter: 'ёбнуло'
};

var ебать = {
  type: 'imperfective verb',
  infinitive: 'ебать',
  indicativePastSingularMasculine: 'ебал',
  indicativePastSingularFeminine: 'ебала',
  indicativePastSingularNeuter: 'ебало',
  indicativePastPlural: 'ебали',
  indicativePresentSingularFirstPerson: 'ебу',
  indicativePresentSingularSecondPerson: 'ебёшь',
  indicativePresentSingularThirdPerson: 'ебёт',
  indicativePresentPluralFirstPerson: 'ебём',
  indicativePresentPluralSecondPerson: 'ебёте',
  indicativePresentPluralThirdPerson: 'ебут',
  imperativeSingularSecondPerson: 'еби',
  imperativePluralSecondPerson: 'ебите'
};

var ебаться = {
  type: 'imperfective verb',
  infinitive: 'ебаться',
  indicativePastSingularMasculine: 'ебался',
  indicativePastSingularFeminine: 'ебалась',
  indicativePastSingularNeuter: 'ебалось',
  indicativePastPlural: 'ебались',
  indicativePresentSingularFirstPerson: 'ебусь',
  indicativePresentSingularSecondPerson: 'ебёшься',
  indicativePresentSingularThirdPerson: 'ебётся',
  indicativePresentPluralFirstPerson: 'ебёмся',
  indicativePresentPluralSecondPerson: 'ебётесь',
  indicativePresentPluralThirdPerson: 'ебутся',
  imperativeSingularSecondPerson: 'ебись',
  imperativePluralSecondPerson: 'ебитесь'
};

var ебашить = {
  type: 'imperfective verb',
  infinitive: 'ебашить',
  imperativePluralSecondPerson: 'ебашьте',
  imperativeSingularSecondPerson: 'ебашь',
  indicativePastPlural: 'ебашили',
  indicativePastSingularFeminine: 'ебашила',
  indicativePastSingularMasculine: 'ебашил',
  indicativePastSingularNeuter: 'ебашило',
  indicativePresentPluralFirstPerson: 'ебашим',
  indicativePresentPluralSecondPerson: 'ебашите',
  indicativePresentPluralThirdPerson: 'ебашат',
  indicativePresentSingularFirstPerson: 'ебашу',
  indicativePresentSingularSecondPerson: 'ебашишь',
  indicativePresentSingularThirdPerson: 'ебашит'
};

var заебать = {
  type: 'perfective verb',
  infinitive: 'заебать',
  imperativePluralSecondPerson: 'заебите',
  imperativeSingularSecondPerson: 'заеби',
  indicativeFuturePluralFirstPerson: 'заебём',
  indicativeFuturePluralSecondPerson: 'заебёте',
  indicativeFuturePluralThirdPerson: 'заебут',
  indicativeFutureSingularFirstPerson: 'заебу',
  indicativeFutureSingularSecondPerson: 'заебёшь',
  indicativeFutureSingularThirdPerson: 'заебёт',
  indicativePastPlural: 'заебали',
  indicativePastSingularFeminine: 'заебала',
  indicativePastSingularMasculine: 'заебал',
  indicativePastSingularNeuter: 'заебало'
};

var пиздеть = {
  type: 'imperfective verb',
  infinitive: 'пиздеть',
  imperativePluralSecondPerson: 'пиздите',
  imperativeSingularSecondPerson: 'пизди',
  indicativePastPlural: 'пиздели',
  indicativePastSingularFeminine: 'пиздела',
  indicativePastSingularMasculine: 'пиздел',
  indicativePastSingularNeuter: 'пиздело',
  indicativePresentPluralFirstPerson: 'пиздим',
  indicativePresentPluralSecondPerson: 'пиздите',
  indicativePresentPluralThirdPerson: 'пиздят',
  indicativePresentSingularFirstPerson: 'пизжу',
  indicativePresentSingularSecondPerson: 'пиздишь',
  indicativePresentSingularThirdPerson: 'пиздит'
};

var проебать = {
  type: 'perfective verb',
  infinitive: 'проебать',
  imperativePluralSecondPerson: 'проебите',
  imperativeSingularSecondPerson: 'проеби',
  indicativeFuturePluralFirstPerson: 'проебём',
  indicativeFuturePluralSecondPerson: 'проебёте',
  indicativeFuturePluralThirdPerson: 'проебут',
  indicativeFutureSingularFirstPerson: 'проебу',
  indicativeFutureSingularSecondPerson: 'проебёшь',
  indicativeFutureSingularThirdPerson: 'проебёт',
  indicativePastPlural: 'проебали',
  indicativePastSingularFeminine: 'проебала',
  indicativePastSingularMasculine: 'проебал',
  indicativePastSingularNeuter: 'проебало'
};

var спиздить = {
  type: 'perfective verb',
  infinitive: 'спиздить',
  imperativePluralSecondPerson: 'спиздите',
  imperativeSingularSecondPerson: 'спизди',
  indicativeFuturePluralFirstPerson: 'спиздим',
  indicativeFuturePluralSecondPerson: 'спиздите',
  indicativeFuturePluralThirdPerson: 'спиздят',
  indicativeFutureSingularFirstPerson: 'спизжу',
  indicativeFutureSingularSecondPerson: 'спиздишь',
  indicativeFutureSingularThirdPerson: 'спиздит',
  indicativePastPlural: 'спиздили',
  indicativePastSingularFeminine: 'спиздила',
  indicativePastSingularMasculine: 'спиздил',
  indicativePastSingularNeuter: 'спиздило'
};

var verbs = [ебать, ебаться, ебашить, ёбнуть, заебать, пиздеть, проебать, спиздить];

var похуй = {
  type: 'predicative',
  predicative: 'похуй'
};

var predicatives = [похуй];

var words = /*#__PURE__*/[].concat(adverbs, interjections, nouns, verbs, predicatives);

var flatten = function flatten(words) {
  return words.reduce(function (result, word) {
    Object.values(word).forEach(function (wordForm) {
      return result.push(wordForm);
    });
    return result;
  }, []);
};

var flatWords = /*#__PURE__*/flatten(words);

export { flatWords, words };
//# sourceMappingURL=russian-bad-words.esm.js.map
